import type { MemberPayment } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { ContentCard, detailListStyles as styles } from '@/shared/ui';

export interface QuoteOrderSectionProps {
  /** 살아 있는 주문 id — 없으면(주문을 읽지 못함) 링크를 만들지 않는다. */
  readonly orderId: string | null;
  /** 주문 고객 화면 이름(주문 설계 §4-3) — 내 주문·내 견적·ADMIN 목록과 같은 이름. */
  readonly orderDisplayStatus: string | null;
  /** 주문 상세와 같은 규칙으로 고른 결제 요약 — 결제 시도가 없으면 null. */
  readonly payment: MemberPayment | null;
}

const LINK_CLASS =
  'text-sm font-medium underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground';

/**
 * 주문된 견적의 주문 영역(견적 설계 §6-7) — 주문 상태와 ADMIN 주문 상세·결제 상세 링크. 주문 상세 경로(`/orders/:orderId`)의
 * 라우트 등록은 주문 Task 13 이다. 주문된 견적은 운영자 조작(초안·발행·반려)을 할 수 없다.
 */
export const QuoteOrderSection = ({
  orderId,
  orderDisplayStatus,
  payment,
}: QuoteOrderSectionProps): ReactElement => (
  <ContentCard
    title="주문"
    description="주문된 견적은 운영자 조작(초안·발행·반려)을 할 수 없습니다."
    actions={
      orderId !== null || payment !== null ? (
        <>
          {orderId !== null ? (
            <Link to={`/orders/${orderId}`} className={LINK_CLASS}>
              주문 상세 보기
            </Link>
          ) : null}
          {payment !== null ? (
            <Link to={`/payments/${payment.id}`} className={LINK_CLASS}>
              결제 상세 보기
            </Link>
          ) : null}
        </>
      ) : undefined
    }
  >
    <dl className={styles.list}>
      <dt className={styles.term}>주문 상태</dt>
      <dd>
        {orderDisplayStatus === null ? (
          <span className={styles.empty}>주문 상태를 확인할 수 없습니다.</span>
        ) : (
          orderDisplayStatus
        )}
      </dd>
    </dl>
  </ContentCard>
);
